module.exports = __webpack_public_path__ + "images/eur.0fec62f812fecd7a6dca7ff5957f19f2.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/flags/eur.png
// module id = 444
// module chunks = 0